import path from './images/path.svg'
import React from "react";
import OutsideClickHandler from "../Constants/OutsideClickHandler";
import './popup.css';

function Popup(props) {
    const fnames = [];
    const ftypes = [];
    const {setOpen} = props
    const onSubmit = () => {
        alert("Thank you for submitting!");
    }
    return (

        <div className={"purple-popup"}>
            <OutsideClickHandler callback={() => {
                setOpen(false)
            }}>
                <div className={'join-list'}>
                    <div className={'first-row'}>
                        <img onClick={(() => {
                            setOpen(false)
                        })} src={path} className={'path'} alt={'path'}/>
                    </div>
                    <div id="mc_embed_signup">
                        <div className="wrapper rounded6" id="templateContainer">
                            <div id="templateBody" className="bodyContent rounded6">
                                <div id="subscribeFormWelcome"><span className={'title'}>Join the waiting list</span>
                                    <br/>
                                    <span className={'desc'}>Please fill in your details below</span>
                                </div>
                                <div className="indicates-required"><span className="asterisk">*</span> indicates
                                    required
                                </div>
                                <form onSubmit={onSubmit}
                                      action="https://whiskyinvestmentpartners.us20.list-manage.com/subscribe/post?u=32e55b3bb554fb770d03bcb49&amp;id=40be3d6ec8"
                                      method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"
                                      className="validate" noValidate>
                                    <div id="mc_embed_signup_scroll">
                                        <div className="indicates-required"><span
                                            className="asterisk">*</span> indicates
                                            required
                                        </div>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-FNAME">First Name <span className="asterisk">*</span>
                                            </label>
                                            <input type="text" name="FNAME" id="mce-FNAME"/>
                                        </div>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-LNAME">Last Name <span className="asterisk">*</span>
                                            </label>
                                            <input type="text" name="LNAME" className="required" id="mce-LNAME"/>
                                        </div>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-EMAIL">Email Address <span className="asterisk">*</span>
                                            </label>
                                            <input type="email" name="EMAIL" className="required email"
                                                   id="mce-EMAIL"/>
                                        </div>
                                        <div className="mc-field-group input-group">
                                            <span className={'before-you-go'}>Before you go, let us know what assets you’re most interested in:</span>
                                            <div className={'checks'}>
                                                <li><input type="checkbox" value="1" name="group[21241][1]"
                                                           id="color-1" className={'input-checkbox'}/><label
                                                    htmlFor="color-1">Watches</label></li>

                                                <li><input type="checkbox" value="2" name="group[21241][2]"
                                                           id="mce-group[21241]-21241-1"
                                                           className={'input-checkbox'}/><label
                                                    htmlFor="mce-group[21241]-21241-1">Handbags</label></li>


                                                <li><input type="checkbox" value="4" name="group[21241][4]"
                                                           id="mce-group[21241]-21241-2"
                                                           className={'input-checkbox'}/><label
                                                    htmlFor="mce-group[21241]-21241-2">Cars</label></li>


                                                <li><input type="checkbox" value="8" name="group[21241][8]"
                                                           id="mce-group[21241]-21241-3"
                                                           className={'input-checkbox'}/><label
                                                    htmlFor="mce-group[21241]-21241-3">Wine</label></li>


                                                <li><input type="checkbox" value="16" name="group[21241][16]"
                                                           id="mce-group[21241]-21241-4"
                                                           className={'input-checkbox'}/><label
                                                    htmlFor="mce-group[21241]-21241-4">Art</label></li>


                                                <li><input type="checkbox" value="32" name="group[21241][32]"
                                                           id="mce-group[21241]-21241-5"
                                                           className={'input-checkbox'}/><label
                                                    htmlFor="mce-group[21241]-21241-5">Whisky</label></li>
                                            </div>
                                        </div>
                                        <div id="mce-responses" className="clear foot">
                                            <div className="response" id="mce-error-response"
                                                 style={{display: 'none'}}/>
                                            <div className="response" id="mce-success-response"
                                                 style={{display: 'none'}}/>
                                        </div>
                                        <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input
                                            type="text" name="b_32e55b3bb554fb770d03bcb49_40be3d6ec8" tabIndex="-1"
                                            value=""/></div>
                                        <div className="optionalParent">
                                            <div className="footer-modal-submit">
                                                <input type="submit" value="Submit" name="subscribe"
                                                       id="mc-embedded-subscribe" className="button"/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <script type='text/javascript'
                                        src={'https://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'}/>

                                <script type='text/javascript'>
                                    {() => {
                                        fnames[1] = 'FNAME';
                                        ftypes[1] = 'text';
                                        fnames[2] = 'LNAME';
                                        ftypes[2] = 'text';
                                        fnames[0] = 'EMAIL';
                                        ftypes[0] = 'email';
                                    }}
                                </script>

                            </div>
                        </div>
                    </div>
                </div>
            </OutsideClickHandler>
        </div>

    )
        ;
}


export default Popup;



